import React from "react";
import { connect } from "react-redux";
import { addToCart, updateAddons, matchAddons } from "../Redux/actions";

import BaseUrl from "../Util/BaseUrl";
import ApiSuffix from "../Util/ApiSuffix";
import SkeletonLoader from "../Util/SkeletonLoader/SkeletonLoader";
import ImageLoader from "../Util/ImageLazyLoader/ImageLoader";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

import "./Cart.css";

class Addons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      addingIndex: null,
      addingToCart: false,
    };

    this.baseUrl = BaseUrl;
    this.apiSuffix = ApiSuffix;
  }

  componentDidMount() {
    this.getAddons();
  }

  getAddons = () => {
    const url = this.baseUrl.dev + this.apiSuffix.getAddons;
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ loading: false });
        this.props.updateAddons(data);
        this.checkProductInCart();
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ loading: false });
      });
  };

  addToCart = (item, index) => {
    this.setState({ addingIndex: index, addingToCart: true });
    if (
      this.props.authStore.isAuthenticated &&
      this.props.authStore.userProfile.email
    ) {
      this.addToCartBackEnd(item);
    } else {
      this.addToCartFrontStore(item);
      this.pushToLocalStorage(item);
    }
  };

  pushToLocalStorage = (item) => {
    let filter = {
      productName: item.productName,
      productImageURL: item.productImageURL,
      productCode: item.productCode,
      productDisplayURL: item.productDisplayURL,
      categoryDisplayURL: item.categoryDisplayURL,
      productDiscount: item.productDiscount,
    };
    const product = {
      product: filter,
      selectedVariant: item.variant,
      quantity: 1,
      message: "",
    };
    let products = JSON.parse(localStorage.getItem("products"));
    if (products && products.length > 0) {
      products.push(product);
    } else {
      products = [product];
    }
    localStorage.setItem("products", JSON.stringify(products));
  };

  addToCartFrontStore = (item, id) => {
    let filter = {
      productName: item.productName,
      productImageURL: item.productImageURL,
      productCode: item.productCode,
      productDisplayURL: item.productDisplayURL,
      categoryDisplayURL: item.categoryDisplayURL,
      productDiscount: item.productDiscount,
    };
    const product = {
      id: id,
      product: filter,
      selectedVariant: item.variant,
      quantity: 1,
      message: "",
    };
    this.props.addToCart(product);
    setTimeout(() => {
      this.setState({ addingToCart: false, addingIndex: null });
      this.checkProductInCart();
      if (this.props.verifyCart) {
        this.props.verifyCart();
      }
    }, 1000);
    this.props.updateCartValue();
  };

  addToCartBackEnd = (item) => {
    const user = this.props.authStore.userProfile;
    const cartItem = {
      username: user.email,
      quantity: 1,
      productDisplayURL: item.productDisplayURL,
      variantID: item.variant.id,
      message: "",
    };
    const url = this.baseUrl.dev + this.apiSuffix.addCartItem;
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.props.authStore.authToken,
      },
      body: JSON.stringify(cartItem),
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        this.addToCartFrontStore(item, data.id);
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ loading: false });
      });
  };

  checkProductInCart = () => {
    this.props.matchAddons();
  };

  render = () => {
    return (
      <div className="cart-addons-wrapper">
        {this.state.loading ? (
          <SkeletonLoader />
        ) : (
          <div>
            {this.props.cartStore.addons &&
            this.props.cartStore.addons.length > 0 ? (
              <React.Fragment>
                <div className="ao-product-wrapper">
                  {this.props.cartStore.addons.map((item, index) => (
                    <div className="ao-item-wrapper" key={index}>
                      <div style={{ width: "100%" }}>
                        {item.isOutOfStock ? (
                          <div className="featured-tag">Out of Stock</div>
                        ) : null}
                        <ImageLoader
                          src={item.productImageURL}
                          minUrl={item.productImageURL50}
                          alt={item.productName}
                        />
                      </div>
                      <div className="ao-product-info">
                        {item.productName} (Rs. {item.variant.productPrice})
                      </div>
                      <div style={{ fontSize: "0.8rem", textAlign: "center" }}>
                        (incl. all taxes)
                      </div>
                      {this.state.addingToCart &&
                      this.state.addingIndex === index ? (
                        <CircularProgress />
                      ) : (
                        <div>
                          <Button
                            color={item.added ? "secondary" : "primary"}
                            variant="contained"
                            onClick={(e) =>
                              item.added ? null : this.addToCart(item, index)
                            }
                            disabled={item.isOutOfStock}
                          >
                            <div className="font-monst-bold">
                              {item.added ? "Added" : "Add"}
                            </div>
                          </Button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </React.Fragment>
            ) : null}
          </div>
        )}
      </div>
    );
  };
}

const mapStateToProps = (state) => ({
  cartStore: state.cartStore,
  authStore: state.authStore,
});

const mapDispatchToProps = (dispatch) => ({
  addToCart: (product) => dispatch(addToCart(product)),
  updateAddons: (addons) => dispatch(updateAddons(addons)),
  matchAddons: () => dispatch(matchAddons()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Addons);
